(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-banner"] && !window.DesignMode) return;
  try {
    
  document.querySelectorAll('.countdown-timer__cta a').forEach((button) => {
    button.addEventListener('click', function (e) {
      const targetHash = this.getAttribute('href');
      if (targetHash.startsWith('#')) {
        e.preventDefault(); // Prevent default anchor click behavior
        const targetClass = targetHash.substring(1); // Extract the class or ID from the hash
        const targetElement = document.getElementById(targetClass) || document.querySelector('.' + targetClass);

        if (targetElement) {
          const offset = document.querySelector('.header ').offsetHeight;
          const elementPosition = window.pageYOffset + targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition - offset;

          // Smooth scroll to the target element considering the offset
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });

          // Update the URL hash without page jump
          history.pushState(null, null, targetHash);
        }
      }
    });
  });

  function updateDisplay(timeUnits) {
    document.getElementById('seconds').textContent = timeUnits.seconds.toString().padStart(2, '0');
    document.getElementById('minutes').textContent = timeUnits.minutes.toString().padStart(2, '0');
    document.getElementById('hours').textContent = timeUnits.hours.toString().padStart(2, '0');
    document.getElementById('days').textContent = timeUnits.days.toString().padStart(2, '0');
  }

  function startCountdown() {
    const countdownElement = document.querySelector('.countdown-timer__wrapper');
    const countdownToDate = countdownElement.getAttribute('data-countdown-to');
    const countdownDate = new Date(countdownToDate);

    setInterval(function () {
      const now = new Date();
      let seconds = Math.floor((countdownDate - now) / 1000);

      if (seconds < 0) {
        // Stop the countdown when the target date is reached
        clearInterval(this);
        return;
      }

      const timeUnits = {
        days: Math.floor(seconds / (3600 * 24)),
        hours: Math.floor((seconds % (3600 * 24)) / 3600),
        minutes: Math.floor((seconds % 3600) / 60),
        seconds: seconds % 60,
      };

      updateDisplay(timeUnits);
    }, 1000);
  }

  startCountdown(); // Start the countdown automatically on page load

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
